<template>
  <div class="eu-flex eu-ml_1 eu-px_4 eu-pb_4 gap_container">
    <div class="eu-flex eu-width_100">
      <Bank
        :title="$t('charge.detail.payment-method.boleto.bank')"
        :bank="lastTransaction.bank"
      />
      <DueAt
        v-if="lastTransaction.due_at"
        :title="$t('charge.detail.payment-method.boleto.due-at')"
        :dueAt="lastTransaction.due_at"
      />
    </div>
    <div class="eu-flex eu-width_100">
      <BoletoDetail
        :nosso-numero="lastTransaction.nosso_numero"
        :document-number="lastTransaction.document_number"
      />
    </div>
    <div
      v-if="isBusinessPsPOrHybrid"
      class="eu-flex eu-width_100 gap_penalty"
    >
      <BoletoFine
        v-if="lastTransaction.fine"
        :title="$t('charge.detail.payment-method.boleto.fine')"
        :type="boletoPenaltyEnum.FINE"
        :data="lastTransaction.fine"
        :amount="lastTransaction.amount"
        :dueAt="lastTransaction.due_at"
      />
      <BoletoInterest
        v-if="lastTransaction.interest"
        :title="$t('charge.detail.payment-method.boleto.interest')"
        :type="boletoPenaltyEnum.INTEREST"
        :data="lastTransaction.interest"
        :amount="lastTransaction.amount"
        :dueAt="lastTransaction.due_at"
      />
    </div>
    <div class="eu-flex eu-width_100">
      <BoletoLine
        v-if="lastTransaction.line"
        :line="lastTransaction.line"
      />
    </div>
    <div class="eu-flex eu-width_100">
      <BoletoUrl
        v-if="lastTransaction.url"
        :url="lastTransaction.url"
      />
    </div>
  </div>
</template>

<script>
import { BOLETO_PENALTY_ENUM } from '@/enums/boleto-penalty.enum'
import { isPsPOrHybrid } from '@/enums/business-model.enum'
import { mapGetters } from 'vuex'

export default {
  name: 'ChargesPaymentMethodBoleto',
  components: {
    Bank: () => import('../../components/Bank.vue'),
    DueAt: () => import('../../components/DueAt.vue'),
    BoletoUrl: () => import('./BoletoUrl.vue'),
    BoletoDetail: () => import('./BoletoDetail.vue'),
    BoletoFine: () => import('./BoletoPenalty'),
    BoletoInterest: () => import('./BoletoPenalty'),
    BoletoLine: () => import('./BoletoLine')
  },
  data () {
    return {
      boletoPenaltyEnum: BOLETO_PENALTY_ENUM
    }
  },
  props: {
    lastTransaction: {
      required: true
    }
  },
  computed: {
    ...mapGetters({
      businessModel: 'businessModel'
    }),
    isBusinessPsPOrHybrid () {
      return isPsPOrHybrid(this.businessModel)
    }
  }
}
</script>

<style scoped>
.gap_container {
  gap: 16px 0;
}

.gap_penalty {
  gap: 16px 0;
}
</style>
